<app-loader></app-loader>
<div class="delete-outer">
    <div class="modal-inner-wraper">
        <div class="important-msg-outer">
            <img src="../../assets/images/important-msg.svg" alt="" />
            <h5>Important Message</h5>
        </div>
        <p>{{bodyText}}</p>
        <p *ngIf="extraError" class="error-text">{{extraError}}</p>
        <div class="common-flex-column">
            <p-button label="Continue" class="w-100 btn-continue" (onClick)="continue()"></p-button>
        </div>
    </div>
</div>